<div class="container-md mb-4"
     id="reviewsContainerId">
  <h2 class="h4 dvi-themed-text-color fw-bold mb-4"
      [translate]="'SALON-DETAILS.REVIEWS-SECTION.HEADER'"></h2>
  <div class="row">
    <div class="col-12 col-lg-4">
      <div class="row justify-content-center">
        <div class="col-12 col-sm-8 col-md-6 col-lg-12">
          <app-reviews-summary [reviewsSummary]="salonDetails">
          </app-reviews-summary>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-8">
      <div class="mb-5">
        <app-review-item *ngFor="let review of salonReviews.reviews"
                         [review]="review">
        </app-review-item>
      </div>
      <a *ngIf="canBeLoadedMore"
         href="#"
         (click)="loadMoreReviews(); false"
         [translate]="'SALON-DETAILS.REVIEWS-SECTION.LINK-LOAD-MORE-REVIEWS'">
      </a>
    </div>
  </div>
</div>
